import React from 'react';
import './Contractjob.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const Textcoldescribe3 = () => {
    return(
        <>
        <Container>
            <Row className='textrow'>
                    <Col sm={12} className='textcol'>
                        <h4>Prepare for Interviews</h4>
                        <p>We provide training and support in resume and cover letter preparation, as well as multiple
                            rounds of mock interviews. Our team of technical recruiting experts will help you prepare for
                            and succeed in interviews.</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
} 

export default Textcoldescribe3